import { createSlice } from "@reduxjs/toolkit";

export const filterSlice= createSlice({
    name:"filter",
    initialState:{
        brands:[],
    },
    reducers:{
        selectBrand:(state,action)=>{
            state.brands.push(action.payload);
        },
        removeBrand:(state,action)=>{
            const indexToRemove = state.brands.indexOf(action.payload);
            if (indexToRemove !== -1) {
                state.brands.splice(indexToRemove, 1);
            }
        }
        ,resetBrand:(state,action)=>{
            state.brands = []
        }
    }
})

export const {selectBrand,removeBrand,resetBrand} =filterSlice.actions;
export default filterSlice.reducer;